import { useMutation, useQueryClient } from '@tanstack/react-query';
import { makeRemoteRecategorizeQueueRequest } from 'main/factories/usecases/queue/remote-recategorize-queue-request';
import { FIVE_SECONDS, showToast, TEN_SECONDS, TOAST_ERROR, TOAST_SUCCESS } from 'lib/utils';
import { AskRequest, AskRequestStatus } from '@hone-automation/common';
import { UIFlaggedTransaction } from 'types/askcustomer';
import { invalidateQueueRequestsForLocation } from './queueQueryKeys';

export const useRecategorizeQueueRequestMutation = (
  locationId: string,
  status: AskRequestStatus,
  onSuccessCallback?: (trx: UIFlaggedTransaction | undefined, data: AskRequest) => void
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: { trxId: string; newAccountId: string; comment: string }) => {
      const service = makeRemoteRecategorizeQueueRequest(data.trxId);
      return service.post({ locationId, newAccountId: data.newAccountId, comment: data.comment });
    },
    onSuccess: async data => {
      // Invalidate queue counts to update badge numbers
      await queryClient.invalidateQueries({ queryKey: ['queueRequestsCount', locationId] });
      await queryClient.invalidateQueries({ queryKey: ['flaggedTransactions', locationId] });
      // Invalidate new query key format (used by useGetQueueRequestsQuery in QueueContext)
      invalidateQueueRequestsForLocation(queryClient, locationId);

      onSuccessCallback?.(undefined, data as AskRequest);
      showToast('Request Re-categorized', TOAST_SUCCESS, FIVE_SECONDS);
    },
    onError: () => {
      showToast('Error while updating request', TOAST_ERROR, TEN_SECONDS);
    },
  });
};
